._content-wrapper_uju1o_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 48px; }
